import api from './api';

export const listarInstituicoes = async () => {
  try {
    const response = await api.get('/instituicoes');
    return response.data;
  } catch (error) {
    console.error('Erro ao listar instituições:', error.response?.data);
    throw error;
  }
};

export const obterInstituicao = async (id) => {
  try {
    const response = await api.get(`/instituicoes/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao obter instituição ${id}:`, error.response?.data);
    throw error;
  }
};

export const criarInstituicao = async (instituicaoData) => {
  try {
    const response = await api.post('/instituicoes', instituicaoData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao criar instituição:', error.response?.data);
    throw error;
  }
};

export const atualizarInstituicao = async (id, instituicaoData) => {
  try {
    const response = await api.put(`/instituicoes/${id}`, instituicaoData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar instituição ${id}:`, error.response?.data);
    throw error;
  }
};

export const excluirInstituicao = async (id) => {
  try {
    const response = await api.delete(`/instituicoes/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao excluir instituição ${id}:`, error.response?.data);
    throw error;
  }
};

// Função adaptada para obter dados do perfil da instituição
export const obterDadosInstituicao = async (id) => {
  try {
    const response = await api.get(`/instituicoes/${id}`);
    // Aqui você pode filtrar ou transformar os dados conforme necessário para o perfil
    const dadosPerfil = {
      nome: response.data.nome,
      email: response.data.email,
      telefone: response.data.telefone,
      website: response.data.website,
      descricao: response.data.descricao,
      logo: response.data.logo
    };
    return dadosPerfil;
  } catch (error) {
    console.error(`Erro ao obter dados do perfil da instituição ${id}:`, error.response?.data);
    throw error;
  }
};

// Função adaptada para atualizar o perfil da instituição
export const atualizarPerfilInstituicao = async (id, perfilData) => {
  try {
    // Aqui você pode adicionar lógica para garantir que apenas os campos do perfil sejam atualizados
    const response = await api.put(`/instituicoes/${id}`, perfilData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar perfil da instituição ${id}:`, error.response?.data);
    throw error;
  }
};